/** @jsxImportSource @emotion/react */
import { css, useTheme } from '@emotion/react'
import React, { useContext } from 'react'
import { ThemeUI } from '../../../theme'
import { Button, Card, Text } from '../../atoms'
import { ContentSection } from '../../organisms'
import * as styles from './index.styles'
import { Context } from '../../../context/QuestionsContext'
import { useDispatch, useSelector } from 'react-redux'
import {useNavigate, useParams} from 'react-router-dom'
import { create_question } from '../../../redux/actions/questions/create_question'
import {update_questions} from "../../../redux/actions/questions/update_questions";

const NewPreview: React.FC = () => {
  const APP_URL = process.env.REACT_APP_URL
  const theme = useTheme() as ThemeUI
  const navigate = useNavigate()
  const { formData } = useContext(Context)
  const dispatch = useDispatch()
  const token = useSelector((state: any) => state.login.access)
  let { id } = useParams();

  const handleBanners = (token: any, formData: any) => {
    if (id) {
      if (!formData.image?.name) {
        formData.image = formData.image.indexOf('/media/')>-1 ? undefined : formData.image
      }
      dispatch(update_questions({ token, formData, navigate }))
    } else {
      dispatch(create_question({ token, formData, navigate }))
    }
  }

  return (
    <ContentSection
      style={styles.root}
      header={
        <Text textType="p" weight="bold">
          Vista Previa
        </Text>
      }
    >
      <div css={(theme: any) => styles.preview(theme)}>
        <Card style={css({ overflow: 'hidden' })}>
          <img
            src={
              formData.image
                ? (formData.image?.name ? URL.createObjectURL(formData.image): APP_URL+''+formData.image)
                : 'https://via.placeholder.com/300x200'
            }
            alt="placeholder"
            css={styles.previewImage}
          />
          <div css={styles.previewDescription(theme)}>
            <Text textType="sm" weight="bold">
              {formData.question}
            </Text>
            <Text textType="sm" weight="light">
              {formData.answer}
            </Text>
          </div>
        </Card>
      </div>
      <Button onClick={() => handleBanners(token, formData)} disabled={!formData.question || !formData.answer || !formData.image}>
        {!id ? 'Publicar' : 'Guardar'} pregunta
      </Button>
    </ContentSection>
  )
}

export default NewPreview
